'use strict';

import angular from 'angular';
import template from './modal.pug';

const VerifyAccountModalSvc = [
  'ModalSvc',
  'LoaderSvc',
  '$location',
  'StripeSvc',
  function(ModalSvc, LoaderSvc, $location, StripeSvc) {
    function extractErrorMessage(err, fallback) {
      return err && err.data && err.data.message
        || err && err.data && err.data.error && err.data.error.message
        || err && err.message
        || err && err.raw && err.raw.message
        || fallback
        || 'An error occurred';
    }

    function getSnapshotMicrodepositType(account) {
      return account.microdeposit_type
        || (account.setup_intent_next_action
          && account.setup_intent_next_action.type
            === 'verify_with_microdeposits'
          && account.setup_intent_next_action.verify_with_microdeposits
          ? account.setup_intent_next_action
            .verify_with_microdeposits.microdeposit_type
          : null);
    }

    function resolveVerificationMode(account) {
      var snapshotMicrodepositType = getSnapshotMicrodepositType(account);

      return StripeSvc.getAccountVerifyMode(account.id)
        .then(function(result) {
          var resolvedType = result && result.microdepositType
            ? result.microdepositType
            : snapshotMicrodepositType;

          return {
            microdepositType: resolvedType,
            requiresVerification: result
              ? !!result.requiresVerification
              : false,
            setupIntentStatus: result ? result.setupIntentStatus : null
          };
        })
        .catch(function() {
          return {
            microdepositType: snapshotMicrodepositType,
            requiresVerification: account.status === 'pending_microdeposits'
              || account.status === 'pending',
            setupIntentStatus: account.setup_intent_status || null
          };
        });
    }

    function open(account) {
      return resolveVerificationMode(account).then(function(resolvedMode) {
        var modalInstance;
        var modalvm = {};

        var microdepositType = resolvedMode.microdepositType || null;
        var isDescriptorCode = microdepositType === 'descriptor_code'
          ? true
          : microdepositType === 'amounts'
            ? false
            : null;
        var isModeResolved = isDescriptorCode === true
          || isDescriptorCode === false;

        var formvm = {
          accountDisplay: `${account.bank_name} ****${account.last4}`,
          amounts: ['0.', '0.'],
          descriptorCode: ''
        };

        ////////////////////////////////////////////////////////////////////////
        // Testing Data
        ////////////////////////////////////////////////////////////////////////
        var url = $location.absUrl();
        var isTestingEnv = url.toLowerCase().includes('sandbox')
          || url.toLowerCase().includes('staging')
          || url.toLowerCase().includes('localhost');
        if(isTestingEnv) {
          if(isDescriptorCode === true) {
            formvm.descriptorCode = 'SM11AA';
          } else if(isDescriptorCode === false) {
            // default fake amounts
            formvm.amounts = ['0.32', '0.45'];
          }
          modalvm.isTesting = true;
        }

        ////////////////////////////////////////////////////////////////////////
        // Account Form Setup
        ////////////////////////////////////////////////////////////////////////
        // submit
        function onSubmit() {
          LoaderSvc.start();

          if(!isModeResolved && resolvedMode.requiresVerification) {
            return LoaderSvc.stopError(
              'Unable to determine verification method. '
              + 'Please refresh and try again.'
            );
          }

          if(isDescriptorCode === true) {
            var code = (modalvm.formvm.descriptorCode || '')
              .trim()
              .toUpperCase();
            var descriptorCodeError = 'Descriptor code must be 6 characters '
              + 'and start with SM.';

            if(!code) {
              return LoaderSvc.stopError('Missing Descriptor Code');
            }
            if(!/^SM[A-Z0-9]{4}$/.test(code)) {
              return LoaderSvc.stopError(descriptorCodeError);
            }

            StripeSvc.verifyAccount(account.id, null, code).then(function(res) {
              LoaderSvc.stopSuccess('Bank Account Verified');
              modalInstance.close(res);
            })
              .catch(function onError(err) {
                var errMsg = extractErrorMessage(
                  err,
                  'Invalid Bank Account Verification'
                );
                modalvm.verificationError = errMsg;
                LoaderSvc.stopError(errMsg);
              });
          } else if(isDescriptorCode === false) {
            var amounts = angular.copy(modalvm.formvm.amounts);

            if(!amounts[0] || !amounts[1]) {
              return LoaderSvc.stopError('Missing Verification Amounts');
            }
            amounts = amounts.map(function(a) {
              a = a < 1 ? Math.round(Number(a) * 100) : a;
              return a;
            });

            // send account token to server to add to user
            StripeSvc.verifyAccount(account.id, amounts).then(function(res) {
              LoaderSvc.stopSuccess('Bank Account Verified');
              modalInstance.close(res);
            })
              .catch(function onError(err) {
                var errMsg = extractErrorMessage(
                  err,
                  'Invalid Bank Account Verification'
                );
                modalvm.verificationError = errMsg;
                LoaderSvc.stopError(errMsg);
              });
          } else {
            LoaderSvc.stopError(
              'Unable to determine verification method. '
              + 'Please refresh and try again.'
            );
          }
        }

        function onCancel() {
          modalInstance.dismiss();
        }

        var modalScope = {modalvm: angular.extend(modalvm, {
          title: 'Verify Bank Account',
          dismissable: true,
          isDescriptorCode,
          microdepositType,
          isModeResolved,
          requiresVerification: resolvedMode.requiresVerification,
          setupIntentStatus: resolvedMode.setupIntentStatus,
          formvm,
          buttons: [
            {classes: 'btn-primary', text: 'Verify', click: onSubmit},
            {classes: 'btn-default', text: 'Cancel', click: onCancel}
          ]
        })};

        var options = {template};

        modalInstance = ModalSvc.open(modalScope, options);
        return modalInstance.result;
      });
    }

    // Public API here
    return {
      open
    };
  }
];

export default VerifyAccountModalSvc;
